const children = [
  {
    path: '',
    component: () => import('@/views/supplyEcosystem/index.vue'),
    children: [
      {
        path: '',
        redirect: 'dashboard'
      },
      {
        path: 'dashboard',
        name: 'supplyEcosystem',
        meta: { title: '首页', currentPage: 'dashboard' },
        component: () => import('@/views/supplyEcosystem/pages/HomeBlank.vue')
      },
      {
        path: 'basic-info',
        name: 'supplyEcosystemBasicInfo',
        meta: { title: '基础信息维护', currentPage: 'basic-info' },
        component: () => import('@/views/supplyEcosystem/pages/BasicInfo.vue')
      },
      {
        path: 'account-management',
        name: 'supplyEcosystemAccountManagement',
        meta: { title: '账号管理', currentPage: 'account-management' },
        component: () => import('@/views/supplyEcosystem/pages/AccountManagement.vue')
      },
      {
        path: 'change-password',
        name: 'supplyEcosystemChangePassword',
        meta: { title: '修改密码', currentPage: 'change-password' },
        component: () => import('@/views/supplyEcosystem/pages/ChangePassword.vue')
      },
      {
        path: 'file-management',
        name: 'supplyEcosystemFileManagement',
        meta: { title: '文件管理', currentPage: 'file-management' },
        component: () => import('@/views/supplyEcosystem/pages/FileManagement.vue')
      },
      {
        path: 'platform-policy',
        name: 'supplyEcosystemPlatformPolicy',
        meta: { title: '平台政策', currentPage: 'platform-policy' },
        component: () => import('@/views/supplyEcosystem/pages/PlatformPolicy.vue')
      },
      {
        path: 'contact-us',
        name: 'supplyEcosystemContactUs',
        meta: { title: '联系我们', currentPage: 'contact-us' },
        component: () => import('@/views/supplyEcosystem/pages/ContactUs.vue')
      },
      {
        path: 'purchase-list',
        name: 'supplyEcosystemPurchaseList',
        meta: { title: '平台待采购清单', currentPage: 'purchase-list' },
        component: () => import('@/views/supplyEcosystem/pages/PurchaseList.vue')
      },
      {
        path: 'product',
        name: 'supplyEcosystemProduct',
        meta: { title: '产品中心', currentPage: 'product' },
        component: () => import('@/views/supplyEcosystem/pages/Product.vue')
      },
      {
        path: 'product/price-system',
        name: 'supplyEcosystemPriceSystem',
        meta: { title: '多规格价格体系', currentPage: 'product', subPage: 'pricing' },
        component: () => import('@/views/supplyEcosystem/pages/Product.vue')
      },
      {
        path: 'product/demo',
        name: 'supplyEcosystemProductDemo',
        meta: { title: '在线模拟与演示', currentPage: 'product', subPage: 'demo' },
        component: () => import('@/views/supplyEcosystem/pages/Product.vue')
      },
      {
        path: 'product/compare',
        name: 'supplyEcosystemProductCompare',
        meta: { title: '竞品差异分析', currentPage: 'product', subPage: 'compare' },
        component: () => import('@/views/supplyEcosystem/pages/Product.vue')
      },
      {
        path: 'opportunity',
        name: 'supplyEcosystemOpportunity',
        meta: { title: '商机引擎', currentPage: 'opportunity' },
        component: () => import('@/views/supplyEcosystem/pages/Opportunity.vue')
      },
      {
        path: 'fulfillment',
        name: 'supplyEcosystemFulfillment',
        meta: { title: '履约协同', currentPage: 'fulfillment' },
        component: () => import('@/views/supplyEcosystem/pages/Fulfillment.vue')
      },
      {
        path: 'support',
        name: 'supplyEcosystemSupport',
        meta: { title: '技术支持', currentPage: 'support' },
        component: () => import('@/views/supplyEcosystem/pages/Support.vue')
      },
      {
        path: 'resource',
        name: 'supplyEcosystemResource',
        meta: { title: '找资源', currentPage: 'resource' },
        // component: () => import('@/views/supplyEcosystem/pages/Resource.vue')
        // component: () => import('@/views/supplyEcosystem/pages/Opportunities/index.vue')
        component: () => import('@/views/opportunities/index.vue')
      },
      {
        path: 'brand',
        name: 'supplyEcosystemBrand',
        meta: { title: '品牌赋能', currentPage: 'brand' },
        component: () => import('@/views/supplyEcosystem/pages/Brand.vue')
      },
      {
        path: 'authentication/basic-info',
        name: 'supplyEcosystemAuthenticationBasicInfo',
        meta: { title: '供应商认证', currentPage: 'authentication' },
        component: () => import('@/views/supplyEcosystem/pages/Authentication/basic-info.vue')
      },
      {
        path: 'authentication/change',
        name: 'supplyEcosystemAuthenticationChange',
        meta: { title: '变更供应商信息', currentPage: 'authentication' },
        component: () => import('@/views/supplyEcosystem/pages/Authentication/change.vue')
      },
      {
        path: 'authentication/submitted',
        name: 'supplyEcosystemAuthenticationSubmitted',
        meta: { title: '提交审核', currentPage: 'authentication' },
        component: () => import('@/views/supplyEcosystem/pages/Authentication/submitted.vue')
      },
      {
        path: 'authentication/succeed',
        name: 'supplyEcosystemAuthenticationSucceed',
        meta: { title: '注册成功', currentPage: 'authentication' },
        component: () => import('@/views/supplyEcosystem/pages/Authentication/succeed.vue')
      }
    ]
  }
]

export { children }
export default children

